import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import textLabel from '../textLabel/textLabel';
import symbol from '../symbol/symbol';
import textTypes from '../textLabel/textTypes';
var ButtonContent = function ButtonContent(props) {
  return /*#__PURE__*/React.createElement('div', {
    'data-hook': props.dataHook,
    className: props.getClassName('control-button-content')
  }, props.symbol ? /*#__PURE__*/React.createElement(symbol, {}, props.symbol) : null, /*#__PURE__*/React.createElement(textLabel, {
    value: props.value,
    type: props.type,
    shouldTranslate: props.shouldTranslate
  }));
};
ButtonContent.displayName = displayNames.BUTTON_CONTENT;
ButtonContent.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** value */
  value: PropTypes.string.isRequired,
  /** symbol */
  symbol: PropTypes.element,
  /** type */
  type: PropTypes.oneOf(textTypes.TYPES)
};
ButtonContent.defaultProps = {
  type: textTypes.BUTTON_CONTENT_DEFAULT_TYPE
};
export default compose(ButtonContent);